import React from 'react'
import { Fade } from 'react-awesome-reveal'
import { testimonials } from '../../utility/testimonials';
import { SwiperSlide, Swiper } from 'swiper/react';
import { Pagination } from 'swiper/modules';

function Testimonials() {
    return (
        <section className="section-testimonial-us padding-tb-100">
            <img src="assets/img/effect/theme-2.png" alt="theme" className="theme-5" />
            <img src="assets/img/effect/theme-6.png" alt="theme" className="theme-6" />
            <div className="container">
                <div className="row">
                    <Fade triggerOnce direction='up' duration={2000} className="col-12 col-lg-6">
                        <img src="assets/img/home/about.png" alt="testimonial" className="testimonial-image" />
                    </Fade>
                    <Fade triggerOnce direction='up' duration={2000} className="col-12 col-lg-6">
                        <div className="testimonial-contain">
                            <div
                                className="swiper zx-swip-testimonial" >
                                <div className="banner t-left">
                                    <h2>What peopele<br></br>are saying about us</h2>
                                </div>
                                <Swiper
                                    pagination={{
                                        clickable: true,
                                    }}
                                    modules={[Pagination]}
                                    loop={true}
                                    autoplay={{ delay: 3000 }} // Adjust delay as per your requirement
                                    spaceBetween={500}
                                    slidesPerView={1}
                                    className="swiper-wrapper pagipagination-testimonial "
                                >
                                    {
                                        testimonials.map((data, index) => (
                                            <SwiperSlide key={index} className="swiper-slide">
                                                <div className="zx-thom">
                                                    <img src={data.icon} alt="icons" />
                                                </div>
                                                <div className="testimonial-icons">
                                                    <i className="fa-solid fa-star"></i>
                                                    <i className="fa-solid fa-star"></i>
                                                    <i className="fa-solid fa-star"></i>
                                                    <i className="fa-solid fa-star"></i>
                                                    <i className="fa-solid fa-star"></i>
                                                </div>
                                                <p>
                                                    {data.discription}
                                                </p>
                                                <div className="testimonial-smith d-flex">
                                                    <img src={data.image} alt="men" />
                                                    <div className="smith-content">
                                                        <h4>{data.name}</h4>
                                                        <p>{data.title}</p>
                                                    </div>
                                                </div>
                                            </SwiperSlide>
                                        ))
                                    }
                                    <div >
                                        <div className='swiper-pagination'></div>
                                    </div>
                                </Swiper>
                            </div>
                        </div>
                    </Fade>
                </div>
            </div>
        </section>
    )
}

export default Testimonials
